<template>
  <div class="send-record">
    <div class="top">
      <Header ref="header" moduleTitle="预配舱单-上海">
        <template slot="searchBox">
          <SendSearch ref="sendSearch" @fnSearch="searchList" @refreshSearch="refreshSearch" @exportExcel="exportExcel" />

        </template>
      </Header>
    </div>
    <div class="send-record-content">
      <el-button type="primary" icon="el-icon-position" :disabled="disabledSend" @click="updateOrder">改单</el-button>
      <el-button type="primary" icon="el-icon-delete" :disabled="disabledSend" @click="deleteOrder">删单</el-button>
      <!-- <el-button type="primary" style="width:118px">
        <i class="iconfont icon-fasong"></i>
        发送VGM
      </el-button> -->
      <WTable :WTableOpts="WTableOpts" @selection-change="handleSelectionChange">
        <!-- <template #payOrderId="{ row }">
          <div class="flex">
            <div class="table-content">{{ row.payOrderId }}</div>
            <div class="content-center" v-if="row.payOrderId" @click="copy(row.payOrderId)"><i class="iconfont icon-fuzhi"></i></div>
          </div>
        </template> -->
        <template #masterBillNo="{ row }">
          <div class="flex">
            <div class="table-content">{{ row.masterBillNo }}</div>
            <div class="content-center" v-if="row.masterBillNo" @click="copy(row.masterBillNo)"><i class="iconfont icon-fuzhi"></i></div>
          </div>
        </template>
        <template #houseBillNo="{ row }">
          <div class="flex">
            <div class="table-content">{{ row.houseBillNo }}</div>
            <div class="content-center" v-if="row.houseBillNo" @click="copy(row.houseBillNo)"><i class="iconfont icon-fuzhi"></i></div>
          </div>
        </template>
        <template #shipName="{ row }">
          <div class="flex">
            <div class="table-content max-200">{{ row.shipName }}</div>
            <div class="content-center" v-if="row.shipName" @click="copy(row.shipName)"><i class="iconfont icon-fuzhi"></i></div>
          </div>
        </template>
        <template #voyageNo="{ row }">
          <div class="flex">
            <div class="table-content max-200">{{ row.voyageNo }}</div>
            <div class="content-center" v-if="row.voyageNo" @click="copy(row.voyageNo)"><i class="iconfont icon-fuzhi"></i></div>
          </div>
        </template>

        <template #ackStatus="{ row }">
          <div class="flex">
            <div class="table-content max-200" :class="getAckStatus(row.ackStatus)" v-if="row.ackStatus">{{ row.ackStatus.show }}</div>
            <div v-else>/</div>
          </div>
        </template>

        <template #ackContent="{ row }">
          <div class="flex">
            <div class="table-content max-200" v-if="row.ackStatus">{{ (row.ackStatus.detail && row.ackStatus.detail.remark) ? row.ackStatus.detail.remark : '/' }}</div>
            <div v-else>/</div>
          </div>
        </template>

        <template #customsStatus="{ row }">
          <div v-if="row.ackStatus && row.ackStatus.dispositionCode == 'CCAM_NEW_SUCCESS'">
            <div class="flex">
              <div @click="getQueryCustoms(row)" class="table-content max-200 w-green-1 cursor-pointer custom" v-if="row.customsStatus && row.customsStatus.type">回执成功</div>
              <div @click="getQueryCustoms(row)" class="table-content max-200 w-blue-1 cursor-pointer custom" v-else>点击获取</div>
            </div>
          </div>
          <div v-else>/</div>
        </template>

        <template #loadStatus="{ row }">
          <div v-if="row.ackStatus && row.ackStatus.dispositionCode == 'CCAM_NEW_SUCCESS'">
            <div class="flex" v-if="row.loadStatus">
              <div class="table-content max-200 " :class="getLoadStatus(row.loadStatus)">{{ row.loadStatus.show }}</div>
              <div class="content-center cursor-pointer" v-if="row.loadStatus && row.loadStatus.dispositionCode == 'CCAM_LOAD_WAITING'" @click="refreshLoadStatus(row)"><i class="iconfont icon-shuaxin"></i></div>
            </div>
            <div v-else class="flex">
              <div class="table-content max-200 w-yellow-1">待回执</div>
              <div class="content-center cursor-pointer" @click="refreshLoadStatus(row)"><i class="iconfont icon-shuaxin"></i></div>
            </div>
          </div>
          <div v-else>/</div>

        </template>

        <template #loadContent="{ row }">
          <div v-if="row.ackStatus && row.ackStatus.dispositionCode == 'CCAM_NEW_SUCCESS'">
            <div class="flex">
              <div class="table-content max-200" v-if="row.loadStatus">{{ (row.loadStatus.detail && row.loadStatus.detail.remark) ? row.loadStatus.detail.remark : '/' }}</div>
              <div v-else>/</div>
            </div>
          </div>
          <div v-else>/</div>
        </template>

        <template #newOperator="{ row }">
          <span v-if="row.modifierUser && row.modifierUser.nickname">{{ row.modifierUser.nickname }}</span>
          <span v-else>{{ row.creatorUser ? row.creatorUser.nickname : '/' }}</span>
        </template>

        <template #operation="{ row }">
          <div class="table-btn-box">
            <el-link type="primary" :underline="false" @click="lookCps(row)">查看</el-link>
            <el-link type="primary" :underline="false" @click="copyCps(row)">复制</el-link>
            <!-- <el-link v-if="row.isSendVGM" type="primary" :underline="false" @click="sendVgm(row)">发送VGM</el-link> -->
          </div>
        </template>
      </WTable>
      <div class="pagination" v-if="total > 0">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum" :page-sizes="[10, 20, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" />
      </div>
    </div>
    <!-- 海关总署舱单 -->
    <CustomCps v-if="customCpsVisible" :customData="customData" :visible="customCpsVisible" @closeDialog="closeDialog" />
    <!-- 改单提示 -->
    <UpdateOrderTip v-if="UpdateOrderTipVisible" :visible="UpdateOrderTipVisible" @closeDialog="closeDialog" @startUpdateOrder="startUpdateOrder" />
    <!-- 删单提示 -->
    <OrderDeleteTip v-if="OrderDeleteTipVisible" :visible="OrderDeleteTipVisible" @closeDialog="closeDialog" @getDeleteOrderFee="getDeleteOrderFee" />
    <!-- 删单价格 -->
    <DeleteOrderFee v-if="deleteOrderFeeVisible" :visible="deleteOrderFeeVisible" :deleteFeeData="deleteFeeData" @closeDialog="closeDialog" @deleteSend="deleteSend" />
  </div>
</template>

<script>
import CustomCps from '@/views/new_cps/sendRecord/CustomCps'
import UpdateOrderTip from '@/views/new_cps/sendRecord/UpdateOrderTip'
import Header from "@/components/cps2/Header"
import SendSearch from "./search/SendSearch"
import { drafts } from "@/api/index";

import OrderDeleteTip from '@/views/new_cps/sendRecord/OrderDeleteTip'
import DeleteOrderFee from '@/views/new_cps/sendRecord/DeleteOrderFee'
import download from "downloadjs"
import { httpAgent } from "@/api/ajax";


export default {
  name: "SendRecord",
  components: { 
    CustomCps, Header,
    SendSearch,
    UpdateOrderTip,
    OrderDeleteTip,
    DeleteOrderFee
  },
  data(){
    return {
      total: 0, // 总数 
      pageNum: 1, // 页码 
      pageSize: 10, // 条数
      chooseList: [], // 选中数据
      searchData: {}, // 搜索数据
      UpdateOrderTipVisible: false, // 改单提示
      customData: {}, // 海关总署数据
      customCpsVisible: false, // 海关总署舱单
      OrderDeleteTipVisible: false, // 删单提示
      deleteFeeData: {}, // 删单价格数据
      deleteOrderFeeVisible: false, // 删单价格弹窗
      deleteList: [], // 删除数据

      WTableOpts: {
        data: [],
        tableAttrs: { border: false },
        tableColAttrs: [
          { type: 'selection', selectable: this.isDisabled,fixed:"left" },
          // { prop: 'payOrderId', label: '订单编号', slotName: 'payOrderId', width: '200px' },
          { prop: '', label: '主提单号', slotName: 'masterBillNo', width: '200px' },
          { prop: '', label: '分提单号', slotName: 'houseBillNo', width: '200px' },
          { prop: '', label: '船名', slotName: 'shipName', width: '150px' },
          { prop: '', label: '航次', slotName: 'voyageNo', width: '150px' },
          { prop: 'carrier', label: '船公司', width: '100px' },
          { prop: 'shipAgent', label: '船代', width: '100px' },
          { prop: '', label: '预配回执状态', slotName: 'ackStatus', width: '110px' },
          { prop: '', label: '预配回执摘要', slotName: 'ackContent', width: '200px' },
          { prop: '', label: '海关总署舱单', slotName: 'customsStatus', width: '110px' },
          { prop: '', label: '装载回执状态', slotName: 'loadStatus', width: '110px' },
          { prop: '', label: '装载回执摘要', slotName: 'loadContent', width: '200px' },
          { prop: '', label: '提交人', slotName: 'newOperator', width: '150px'},
          { prop: 'gmtModified', label: '操作时间', 'min-width': '200px' },
          { prop: '', label: '操作', width: '200px', slotName: 'operation',fixed:"right"  }
        ]
      },
      headers:{
        token: localStorage.getItem('userToken'),
      },
    }
  },
  computed: {
    // 删除 按钮状态
    disabledSend(){
      return this.chooseList.length == 1 ? false : true
    },
  },
  created() {
    this.getList()
    //请求头信息补充
    let domain = '';
    if (window.location.host.split('.')[0] == 'www') {
      domain = window.location.host.split('.')[1];
    } else {
      domain = window.location.host.split('.')[0];
    }
    this.headers['X-company-domain'] = domain;
  },
  async mounted(){
    await this.$refs.sendSearch.firstClick()
    await this.$refs.sendSearch.fnSearch()
  },
  methods: {
    // 获取列表
    getList(){
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        ...this.searchData,
        type: 'NEW',
        ackStatus: (this.searchData && this.searchData.ackStatus) ? this.searchData.ackStatus.toString() : '',
        loadStatus: (this.searchData && this.searchData.loadStatus) ? this.searchData.loadStatus.toString() : '',
      }
      httpAgent({
        url: `/agent/ccam/orders`,
        method: "get",
        data:params
      }).then((res) => {
        res.records.forEach(item => {
          if(item.ccamDispositionHistorys && item.ccamDispositionHistorys.length > 0){
            item.ccamDispositionHistorys.forEach(key => {
              if(key.type == 'ACK_STATUS'){
                item.ackStatus = key
              }
              if(key.type == 'DELETE_STATUS'){
                item.deleteStatus = key
              }
              if(key.type == 'LOAD_STATUS'){
                item.loadStatus = key
              }
              if(key.type == 'CUSTOMS_STATUS'){
                item.customsStatus = key
              }
            })
          }
        })

        this.WTableOpts.data = res.records
        this.total = res.total
      })
    },
    // 导流
    sendVgm(row){
      console.log(row);
      //window.location.href = '/vgm?sendVGMId=' + row.id
      this.$router.push({
        name:"vgm",
        query:{
          sendVGMId:row.id
        }
      })
      // drafts.ccamSendVGM(row.id).then(res => {
      //   console.log(res,11111)
      // })
    },
    // 多选状态
    isDisabled(row){
      return row.isOperation
    },
    // 复制
    copy(e){
      this.$copyText(e)
			this.$message({
				type: 'success',
				message: '复制成功!'
			})
    },
    // 获取海关总署
    getQueryCustoms(row){
      httpAgent({
        url: `/agent/ccam/orders/queryCustoms`,
        method: "get",
        data: {id: row.id},
      }).then((res) => {
        console.log(res)
        this.customCpsVisible = true
        this.customData = res
      })
    },
    // 刷新装载回执
    refreshLoadStatus(row){
      this.$confirm('请在确认完成报关之后再刷新装载舱单回执哦！', '提示', {
        confirmButtonText: '我已完成报关',
        cancelButtonText: '再等等',
        type: 'warning'
      }).then(() => {
        httpAgent({
          url: `/agent/ccam/orders/queryLoadingStatus`,
          method: "get",
          data: {id: row.id},
        }).then((res) => {
          this.$message({
            message: '获取中，请稍候刷新页面查看装载回执状态！',
            type: 'success'
          })
        })
      }).catch(() => {});
    },
    // 获取预配回执颜色 
    getAckStatus(row){
      if(row && row.dispositionCode){
        if(row.dispositionCode == 'CCAM_NEW_WAITING'){
          return 'w-yellow-1'
        }
        if(row.dispositionCode == 'CCAM_NEW_SUCCESS'){
          return 'w-green-1'
        }
        if(row.dispositionCode == 'CCAM_NEW_FAILURE'){
          return 'w-red-1'
        }
      }
      
    },
    // 装载回执颜色
    getLoadStatus(row){
      if(row && row.dispositionCode){
        if(row.dispositionCode == 'CCAM_LOAD_WAITING'){
          return 'w-yellow-1'
        }
        if(row.dispositionCode == 'CCAM_LOAD_SUCCESS'){
          return 'w-green-1'
        }
        if(row.dispositionCode == 'CCAM_LOAD_FAILURE'){
          return 'w-red-1'
        }
      }
    },
    // 导出
    exportExcel(query){
      if(!query.gmtModifiedBegin && !query.gmtModifiedEnd){
        this.$message({
          message: '请选择时间',
          type: 'error'
        })
        return
      }
      query.ackStatus = (query && query.ackStatus) ? query.ackStatus.toString() : ''
      query.loadStatus = (query && query.loadStatus) ? query.loadStatus.toString() : ''
      query.token = this.headers.token;
      query['X-company-domain'] = this.headers['X-company-domain'];
      let keys = Object.keys(query);
      let arr = '';
      for(let i=0;i<keys.length;i++){
        if(query[keys[i]]){
          arr = arr + '&' + keys[i] + '=' + query[keys[i]]
        }
      }
      arr = arr.substring(1);
      let url = '/agent/ccam/export?'+arr;
      console.log(url);
      window.open(url);
      // let param = {
      //   ...query,
      //   ackStatus: (query && query.ackStatus) ? query.ackStatus.toString() : '',
      //   loadStatus: (query && query.loadStatus) ? query.loadStatus.toString() : '',
      // }
      // httpAgent({
      //   url: `/agent/ccam/export`,
      //   method: "get",
      //   data: param,
      //   responseType: "blob"
      // }).then((res) => {
      //   download(res, `${'CPS导出数据'}.xlsx`)
      // })
    },
    // 改单进入详情
    startUpdateOrder(){
      httpAgent({
        url: `/agent/ccam/orders/${this.chooseList[0]}`,
        method: 'get',
      }).then((res) => {
        let data = {
          btn: 'UPDATE',
          btnName: '修改舱单',
          type: 'SEND',
          to: 'DETAIL',
          name: '已发送',
          content: {  ...res.houseBill },
          id: this.chooseList[0]
        }
        this.$router.push({
          name:"cpsDetail",
          query:data
        })
      })
    },
    // 改单 提示
    updateOrder(){
      this.UpdateOrderTipVisible = true
    },
    // 确认删单
    deleteSend(){
      let param = {
        fee: this.deleteFeeData.fee,
        houseBillId: this.deleteFeeData.houseBillId,
        relationHouseBillIds: this.deleteFeeData.relationHouseBillIds,
      }
      httpAgent({
        url: `/agent/ccam/orders/deleteSend`,
        method: 'post',
        data:param
      }).then((res) => {
        this.$message({
          message: '操作成功',
          type: 'success'
        })
        this.deleteOrderFeeVisible = false
        this.$refs.header.getAccount()
        this.getList();
      })
    },
    // 点击删单
    deleteOrder(){
      this.OrderDeleteTipVisible = true
    },
    // 获取删单价格
    getDeleteOrderFee(){
      httpAgent({
        url: `/agent/ccam/orders/checkDeleteFee`,
        method: 'get',
        data:{houseBillId: this.deleteList[0]}
      }).then((res) => {
        console.log(res)
        this.deleteFeeData = { ...res, houseBillId: this.deleteList[0] }
        this.deleteOrderFeeVisible = true
      })
    },
    // 重置
    refreshSearch(){
      this.searchData = {}
      this.$refs.sendSearch.refreshTime()
    },
    // 点击查询
    searchList(query){
      this.searchData = query
      this.pageNum = 1
      this.pageSize = 10
      this.getList()
    },
    // 切换条数
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val
      this.getList()
    },
    // 切换页码
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val
      this.getList()
    },

    // 查看舱单
    lookCps({ id }){
      httpAgent({
        url: `/agent/ccam/orders/${id}`,
        method: "get",
      }).then((res) => {
        let data = {
          btn: 'LOOK',
          btnName: '查看舱单',
          type: 'SEND',
          to: 'DETAIL',
          name: '已发送',
          content: {  ...res.houseBill }
        }
        this.$router.push({
          name:"cpsDetail",
          query:data
        })
      })
    },
    // 复制舱单
    copyCps({ id }){
      httpAgent({
        url: `/agent/ccam/orders/${id}`,
        method: "get",
      }).then((res) => {
        let response = { ...res }
        response.masterBillNo = ''
        let data = {
          btn: 'COPY',
          btnName: '复制舱单',
          type: 'SEND',
          to: 'DETAIL',
          name: '已发送',
          content: {  ...response.houseBill }
        }
        this.$router.push({
          name:"cpsDetail",
          query:data
        })
      })
    },
    // table 选择
    handleSelectionChange(e){
      this.chooseList = []
      this.deleteList = []
      this.deleteList = e.map(o => { return o.houseBillId })
      this.chooseList = e.map(o => { return o.id })
    },
    
    // 关闭弹窗
    closeDialog(){
      this.UpdateOrderTipVisible = false

      this.customCpsVisible = false
      this.OrderDeleteTipVisible = false
      this.deleteOrderFeeVisible = false
    },
    
  }
};
</script>

<style scoped lang="less">
.send-record {
  font-size: 14px;
  color: #333333;
  display: flex;
  flex-direction: column;
  height: 100%;
  .custom:hover {
    text-decoration: underline;
  }

  .send-record-content {
    position: relative;
    background: #ffffff;
    border-radius: 4px;
    padding: 24px;
    height: 100%;
  }
  .icon-fuzhi {
    color: #1170eb;
    font-size: 12px;
    cursor: pointer;
    margin-left: 10px !important;
  }
  .icon-shuaxin {
    font-size: 14px;
    color: #000000;
    cursor: pointer;
    margin-left: 6px !important;
  }

  .icon-tijiaoguimianshandan {
    font-size: 12px;
    margin-right: 4px !important;
  }
  .el-button--primary {
    margin-bottom: 24px;
  }
}
</style>
